import { Component, inject, input, OnInit } from '@angular/core';
import { LanguageService } from '../../Services/language.service';

@Component({
  selector: 'app-page-title-gold',
  templateUrl: './page-title-gold.component.html',
  styleUrl: './page-title-gold.component.scss'
})
export class PageTitleGoldComponent implements OnInit{
  ngOnInit(): void {
    this.language = this.languageService.getLanguage();
  }

  input_title = input.required<String>();
  private languageService = inject(LanguageService);
  language = this.languageService.getLanguage();

}
